import { QuackChatConfigResponse } from "@/components/quack-chat/QuackChatConfig.model";
import { SelectOption } from "@/components/shared/select/Select";
import { QuackChatSystemMessageType } from "@/v2/entities/quackchat/Quackchat.model";

export interface QuackChatSystemMessageOverrideProps {
  config: QuackChatConfigResponse;
  defaultMessageType?: QuackChatSystemMessageType;
  isEditing: boolean;
  simulatorId: string | undefined;
  onStartEdit: () => void;
  onStopEdit: () => void;
  onError: () => void;
}

export type FilterOperator =
  | "ne"
  | "eq"
  | "like"
  | "exists"
  | "notExists"
  | "gt"
  | "gte"
  | "lt"
  | "lte";

export const MESSAGE_FILTER_KNOWN_VALUE = "{known}";

export function isMessageFilterKnownValue(value: string): boolean {
  return value === MESSAGE_FILTER_KNOWN_VALUE;
}

export interface MessageFilter {
  id: string;
  field: string;
  operator: FilterOperator;
  value: string;
  knownSourceFieldId?: string;
}

export interface MessageFilterRule {
  id: string;
  message: string;
  conditions: MessageFilter[];
}

export type MessageFilters = Partial<
  Record<QuackChatSystemMessageType, MessageFilterRule[]>
>;

export const operatorOptions: SelectOption[] = [
  { label: "is", value: "eq" },
  { label: "is not", value: "ne" },
  { label: "contains", value: "like" },
  { label: "exists", value: "exists" },
  { label: "not exists", value: "notExists" },
  { label: ">", value: "gt" },
  { label: ">=", value: "gte" },
  { label: "<", value: "lt" },
  { label: "<=", value: "lte" },
];

export const isValuelessOperator = (operator: FilterOperator): boolean =>
  operator === "exists" || operator === "notExists";

export interface FilterRuleDialogProps {
  open: boolean;
  editingRule: MessageFilterRule | null | undefined;
  isSavingFilter: boolean;
  onClose: () => void;
  onSave: (conditions: MessageFilter[], message: string) => void;
  selectedMessageType?: QuackChatSystemMessageType;
}
